import ThumbnailSelector from './thumbnail-selector'

export * from './thumbnail-selector'
export default ThumbnailSelector
